import isEmpty from 'lodash/isEmpty';
import { defineMessages } from 'react-intl';

import GovernmentNumbersEdit from './GovernmentNumbersEdit';
import GovernmentNumbersView from './GovernmentNumbersView';
import { governmentNumbersSchema } from './schema';

import iconSVG from './icons/gov-numbers.svg';

const messages = defineMessages({
  governmentNumbers: {
    id: 'Government numbers',
    defaultMessage: 'Government numbers',
  },
  missingRequired: {
    id: 'Fill the title or subtitle.',
    defaultMessage: 'Fill the title or subtitle.',
  },
});

const missingRequiredValidator = ({ value, formData, formatMessage }) => {
  const fieldsEmpty = !value && isEmpty(formData['title']);
  return fieldsEmpty ? formatMessage(messages.missingRequired) : null;
};

const applyConfig = (config) => {
  config.blocks.blocksConfig.governmentNumbersBlock = {
    id: 'governmentNumbersBlock',
    title: 'Government numbers',
    group: 'govbr',
    icon: iconSVG,
    view: GovernmentNumbersView,
    edit: GovernmentNumbersEdit,
    blockSchema: governmentNumbersSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  config.registerUtility({
    type: 'validator',
    name: 'teste',
    dependencies: {
      blockType: 'governmentNumbersBlock',
      fieldName: 'subtitle',
    },
    method: missingRequiredValidator,
  });
  return config;
};

export default applyConfig;
